// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:992px){.product__purchase.product__purchase--sticky .product__add-to-basket-btn .btn{height:48px!important;padding:10px 30px}}.product__availability__message b{font-family:\"Poppins-SemiBold\",sans-serif;font-weight:800}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
